import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { snakeCase } from 'lodash';

import irelandApi from '../../irelandApi';

import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import SearchableSelect from '../common/form/elements/searchable-select';
import Pagination from '../common/pagination';

import { getPorDeals } from '../../actions/por-deals';
import { loadPageContent } from '../../actions/content';
import { getOutlets } from '../../actions/outlet';
import { dateFormat } from '../../utils/commonFunctions';

import './styles.css';

const sortOptions = [
  {
    value: '0',
    label: 'Distance'
  },
  {
    value: '1',
    label: 'Ending Soonest'
  },
];

class PorDeals extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'por-deals';
    this.state = {
      selectedOutlet: null,
      outletOptions: null,
      selectedSort: { value: '0', label: 'Distance' },
      currentPage: 1,
      totalPages: 0,
      data: []
    };
  }

  handleContentSaved = () => {
    const { dispatch } = this.props;

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  handleOutletChange = (event) => {
    this.setState({
      selectedOutlet: this.state.outletOptions.find(x => x.value === event)
    }, () => {
      this.getDeals();
    });
  };

  handleSortChange = (event) => {
    this.setState({
      selectedSort: sortOptions.find(x => x.value === event)
    }, () => {
      this.getDeals();
    });
  };

  getUrlParameters = () => {
    const { location: { search } } = this.props;

    if (search === '') {
      return search;
    }

    return JSON.parse(`{"${decodeURI(search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
  };

  getDeals = () => {
    const { dispatch } = this.props;
    const { selectedOutlet, selectedSort } = this.state;
    const urlParams = this.getUrlParameters();
    const brandId = urlParams.brand_id;
    const isProduct = urlParams.is_product;

    if (selectedOutlet) {
      if (selectedSort.value === '0') {
        dispatch(getPorDeals(brandId, isProduct, selectedOutlet.value, selectedSort.label.toLowerCase()));
      } else {
        dispatch(getPorDeals(brandId, isProduct, selectedOutlet.value, snakeCase(selectedSort.label.toLowerCase())));
      }
    }
  };

  handleDownloadSkus = (id) => {
    irelandApi.get(`/api/por_deals/${id}/brand_export.csv`)
      .then((response) => {
        const fileName = response.headers['content-disposition'].match(/"([^"]+)"/)[1];
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type, encoding: 'UTF-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
  }

  handleDownloadWholesaler = (id) => {
    irelandApi.get(`/api/por_deals/${id}/wholesaler_export.csv`)
      .then((response) => {
        const fileName = response.headers['content-disposition'].match(/"([^"]+)"/)[1];
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type, encoding: 'UTF-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
  }

  updateSelectedOutlet = () => {
    if (this.props.stores[0]) {
      this.setState({
        selectedOutlet: { value: this.props.stores[0].id, label: this.props.stores[0].attributes.name }
      }, () => {
        this.getDeals();
      });
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.stores !== this.props.stores) {
      const rewardStores = this.props.stores.filter(store => store.attributes.reward === true);
      const outletOptions = rewardStores.map(store => (
        {
          value: store.id,
          label: store.attributes.name
        }
      ));
      this.setState({
        outletOptions
      }, () => {
        this.updateSelectedOutlet();
      });
    }

    if (prevProps.porDeals !== this.props.porDeals) {
      this.setState({
        totalPages: Math.ceil(this.props.porDeals.length / 10),
        currentPage: 1,
        data: this.props.porDeals.slice(0, 10)
      });
    }
  };

  handlePageUpdate = (i) => {
    this.setState({
      currentPage: i,
      data: this.props.porDeals.slice(((i * 10) - 10), ((i * 10) - 10) + 10)
    });
  }

  componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(getOutlets());
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    const { data } = this.state;
    const { porDeals, contents } = this.props;
    const { pageSlug } = this;

    return (
      <div className="por-deals">
        <Grid bsClass="container" className="user-inner-container">
          <Row>
            <Col className="por-deals-title" lg={12}>
              <PageTitle>POR DEALS</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col className="por-deals-editable-content" lg={12}>
              <InlineCKEditor
                contents={contents[`${pageSlug}_content_text`]}
                identifier={`${pageSlug}_content_text`}
                onContentSaved={this.handleContentSaved}
              />
            </Col>
          </Row>
        </Grid>
        <div className="container user-inner-container">
          <div className="por-deals-filters">
            <SearchableSelect
              label='Outlet'
              model='deep.por_deals.outlet_id'
              options={this.state.outletOptions}
              value={this.state.selectedOutlet}
              onChange={e => this.handleOutletChange(e)}
            />
            <SearchableSelect
              label='Sort by'
              model='deep.por_deals.sort'
              options={sortOptions}
              value={this.state.selectedSort}
              onChange={e => this.handleSortChange(e)}
            />
          </div>
          <div className="por-deal-cards-container">
            {data.length > 0 && (
              data.map((deal, index) => (
                <div className="por-deal-card" key={index}>
                  <div className="por-deal-card-image-container">
                    <img src={deal.attributes.image} />
                  </div>
                  <div className="por-deal-card-details-container">
                    <div className="por-deal-card-percentage">
                      {deal.attributes['por-deal-percentage']
                        ? `${deal.attributes['por-deal-percentage']}%`
                        : `£${Number(deal.attributes['por-deal-monetary']).toFixed(2)}`} POR
                    </div>
                    <div className="por-deal-card-wholesaler-detail-container">
                      <div className="por-deal-card-wholesaler-detail">
                        Available at {''}
                        <span className="download-skus" onClick={() => this.handleDownloadWholesaler(deal.id)}>
                          {deal.attributes['wholesaler-subgroup-name']}
                        </span>
                      </div>
                      {deal.attributes.product.name && (
                        <div className="por-deal-card-wholesaler-detail">
                          <span>{deal.attributes.product.name}</span>
                        </div>
                      )}
                      {deal.attributes.brand.name && (
                        <div className="por-deal-card-wholesaler-detail">
                          <span className="download-skus" onClick={() => this.handleDownloadSkus(deal.id)}>
                            Click here to download eligible SKUs
                          </span>
                        </div>
                      )}
                      <div className="por-deal-card-wholesaler-detail">
                        Promotion ends <span>{dateFormat((deal.attributes['end-date']))}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          {porDeals.length > 10 && (
            <div className="por-deals-pagination">
              <Pagination
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                action={this.handlePageUpdate}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  contents: state.content.list,
  porDeals: state.porDeals.data,
  stores: state.stores.stores,
});

export default connect(mapStateToProps)(PorDeals);



// WEBPACK FOOTER //
// ./src/components/por-deals/index.jsx